import Navbar from "../../../components/Layout/Navbar";
import Footer from "../../../components/Layout/Footer";
import PageMeta from "../../../components/pagesHelmet/PageMeta";

const BRAND = {
  primary: "#3B82F6",
  primarySoft: "rgba(59, 130, 246, 0.1)",
  success: "#22C55E",
  warning: "#F59E0B",
  muted: "#6B7280",
  text: "#1F2937",
};

export default function ProductsPage() {
  return (
    <>
      <PageMeta
        title="All-in-One Link Management Platform | U2LR"
        description="Branded URL shortener, dynamic QR codes, and real-time analytics — everything you need to manage and optimize your links."
      />

      <Navbar />

      <div style={{ color: BRAND.text }}>

        {/* ================= HERO ================= */}
        <section
          style={{
            background: `linear-gradient(135deg, #000, ${BRAND.primary})`,
            color: "#fff",
          }}
        >
          <div className="container py-5 text-center">
            <div className="py-5">
              <h1 className="display-5 fw-bold mb-4">
                All-in-One Link Management Platform
              </h1>
              <p
                className="lead mx-auto"
                style={{ maxWidth: 750, color: "rgba(255,255,255,0.85)" }}
              >
                Branded URL shortener, dynamic QR codes, and real-time analytics —
                built to help you create, distribute, and optimize every link.
              </p>
            </div>
          </div>
        </section>

        {/* ================= PRODUCT CARDS ================= */}
        <section className="py-5">
          <div className="container py-4">
            <div className="row g-4">

              {/* URL SHORTENER */}
              <div className="col-lg-4">
                <div className="card h-100 border-0 shadow-sm rounded-4 p-4">
                  <div
                    className="fw-bold mb-3"
                    style={{ color: BRAND.primary, fontSize: "2rem" }}
                  >
                    🔗
                  </div>
                  <h4 className="fw-bold mb-3">URL Shortener</h4>
                  <p style={{ color: BRAND.muted }}>
                    Build branded short links that increase trust and improve
                    click-through rates across every channel.
                  </p>

                  <ul className="list-unstyled small" style={{ color: BRAND.muted }}>
                    <li>✓ Custom aliases & branded links</li>
                    <li>✓ Secure HTTPS redirects</li>
                    <li>✓ Link expiration & editing</li>
                    <li>✓ Integrated performance tracking</li>
                  </ul>

                  <a
                    href="/our-products/url-shortener"
                    className="btn btn-primary mt-3 rounded-pill"
                  >
                    Explore URL Shortener
                  </a>
                </div>
              </div>

              {/* QR CODES */}
              <div className="col-lg-4">
                <div className="card h-100 border-0 shadow-sm rounded-4 p-4">
                  <div
                    className="fw-bold mb-3"
                    style={{ color: BRAND.success, fontSize: "2rem" }}
                  >
                    📱
                  </div>
                  <h4 className="fw-bold mb-3">Dynamic QR Codes</h4>
                  <p style={{ color: BRAND.muted }}>
                    Create trackable QR codes you can update anytime —
                    even after printing — with full scan visibility.
                  </p>

                  <ul className="list-unstyled small" style={{ color: BRAND.muted }}>
                    <li>✓ Editable destination URLs</li>
                    <li>✓ Real-time scan analytics</li>
                    <li>✓ Custom branding & styling</li>
                    <li>✓ Campaign-ready tracking</li>
                  </ul>

                  <a
                    href="/our-products/qr-codes"
                    className="btn btn-success mt-3 rounded-pill"
                  >
                    Explore QR Codes
                  </a>
                </div>
              </div>

              {/* ANALYTICS */}
              <div className="col-lg-4">
                <div className="card h-100 border-0 shadow-sm rounded-4 p-4">
                  <div
                    className="fw-bold mb-3"
                    style={{ color: BRAND.warning, fontSize: "2rem" }}
                  >
                    📊
                  </div>
                  <h4 className="fw-bold mb-3">Real-Time Analytics</h4>
                  <p style={{ color: BRAND.muted }}>
                    Turn every click and scan into actionable insights with
                    advanced tracking and performance intelligence.
                  </p>

                  <ul className="list-unstyled small" style={{ color: BRAND.muted }}>
                    <li>✓ Total & unique click tracking</li>
                    <li>✓ Geographic & device insights</li>
                    <li>✓ Referrer & campaign analysis</li>
                    <li>✓ Performance optimization tools</li>
                  </ul>

                  <a
                    href="/our-products/analytics"
                    className="btn btn-warning mt-3 rounded-pill"
                  >
                    Explore Analytics
                  </a>
                </div>
              </div>

            </div>
          </div>
        </section>

        {/* ================= PLATFORM FLOW ================= */}
        <section className="py-5 bg-light text-center">
          <div className="container py-4">
            <h2 className="fw-bold mb-4">
              Built as One Unified Workflow
            </h2>

            <p
              className="mx-auto mb-5"
              style={{ maxWidth: 720, color: BRAND.muted }}
            >
              Create a branded short link, generate a dynamic QR code,
              and track every interaction in real time — all from one
              centralized dashboard.
            </p>

            <div className="row">
              <div className="col-md-4">
                <h6 className="fw-bold">Create</h6>
                <p style={{ color: BRAND.muted }}>
                  Short links & branded URLs
                </p>
              </div>

              <div className="col-md-4">
                <h6 className="fw-bold">Distribute</h6>
                <p style={{ color: BRAND.muted }}>
                  QR codes & campaign sharing
                </p>
              </div>

              <div className="col-md-4">
                <h6 className="fw-bold">Analyze</h6>
                <p style={{ color: BRAND.muted }}>
                  Clicks, scans & performance insights
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* ================= CTA ================= */}
        <section className="py-5 text-center">
          <div className="container py-4">
            <h2 className="fw-bold mb-3">
              Launch Your First Smart Link in Seconds
            </h2>
            <p className="mb-4" style={{ color: BRAND.muted }}>
              Start shortening, generating, and tracking — with no complexity.
            </p>
            <a
              href="/register"
              className="btn btn-primary btn-lg rounded-pill px-5"
            >
              Get Started Free
            </a>
          </div>
        </section>

      </div>

      <Footer />
    </>
  );
}
